import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { FieldName } from '../types/CardFieldName';
import { type SavedCardInfo } from '../types/SavedCardInfo';

/*
In packages/cashier-payments-widget/src/utils/getCardRequiredFields.ts we have this logic to send data in BI event. If you need to update this function please also update it in widget.
*/

export const getRequiredFields = (params: { providerId: PaymentProvider; savedCard?: SavedCardInfo }): FieldName[] => {
  const { providerId, savedCard } = params;

  if (savedCard) {
    const fields: FieldName[] = [];

    if (savedCard.withCVV) {
      fields.push(FieldName.CVV);
    }

    return fields;
  }

  return [
    FieldName.Number,
    FieldName.ExpireDate,
    FieldName.CVV,
    providerId === PaymentProvider.Square ? FieldName.PostalCode : FieldName.HolderName,
  ];
};
